import { isNewPpsi, isUpdatedPpsi } from '../ppsi/status';

function decoratePpsis(ppsis = [],dateDuration=14) {
  return ppsis.map(ppsi => {
    const isNew = isNewPpsi(ppsi,dateDuration);
    const isUpdated = isUpdatedPpsi(ppsi,dateDuration);
    return {
      ...ppsi,
      isNew,
      isUpdated
    };
  });
}

export default decoratePpsis;
